import { type CoreInquiryResponseList } from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Get all inquiries from logged user.
 *
 * @endpoint GET /api/saas/me/inquiries
 * @scope saas
 * @see https://flecto.dev/api-4724168
 */
export async function getAllInquiries(): Promise<CoreInquiryResponseList> {
  const response = await api.get<CoreInquiryResponseList>(
    '/api/saas/me/inquiries'
  )

  return response.data
}
